export const IMAGING_TEST_DIAGNOSTIC_REPORT_TYPE_MAP: Record<string, string> = {
  Autorefraction: 'AR',
  'Biomagnetic Imaging': 'BI',
  'Bone Mineral Densitometry': 'BMD',
  'Cardiac Electrophysiology': 'EPS',
  'Computed Radiography': 'CR',
  'CT Scan': 'CT',
  Dermoscopy: 'DMS',
  Diaphanography: 'DG',
  'Digital Radiography': 'DX',
  Echocardiography: 'ECHO',
  'Electrocardiography (ECG)': 'ECG',
  'Electroencephalography (EEG)': 'EEG',
  'Electromyography (EMG)': 'EMG',
  'Electrooculography (EOG)': 'EOG',
  Endoscopy: 'ES',
  'External-camera Photography': 'XC',
  'General Microscopy': 'GM',
  'Hemodynamic Waveform': 'HD',
  'Holter Monitoring': 'HOLTER',
  'Intra-oral Radiography': 'IO',
  'Intravascular Optical Coherence Tomography': 'IVOCT',
  'Intravascular Ultrasound': 'IVUS',
  Keratometry: 'KER',
  'Laser Scan': 'LS',
  Lensometry: 'LEN',
  'Magnetic Resonance (MRI)': 'MRI',
  Mammography: 'MG',
  'Nuclear Medicine': 'NM',
  'Ophthalmic Axial Measurements': 'OAM',
  'Ophthalmic Mapping': 'OPM',
  'Ophthalmic Photography': 'OP',
  'Ophthalmic Tomography': 'OPT',
  'Ophthalmic Tomography B-scan Volume Analysis': 'OPTBSV',
  'Ophthalmic Tomography En Face': 'OPTENF',
  'Ophthalmic Visual Field': 'OPV',
  'Optical Coherence Tomography (OCT)': 'OCT',
  'Optical Surface Scanner': 'OSS',
  'Panoramic X-Ray': 'PX',
  'Position Sensor': 'POS',
  'Positron Emission Tomography': 'PT',
  'Pulmonary Functions Test': 'PFT',
  Radiofluoroscopy: 'RF',
  'Radiographic Imaging': 'RG',
  'Respiratory Waveform': 'RESP',
  'RT Image': 'RTIMAGE',
  'Sleep Study': 'SLEEPST',
  'Slide Microscopy': 'SM',
  'Subjective Refraction': 'SRF',
  Thermography: 'TG',
  'Transthoracic Echocardiography (TTE)': 'TTE',
  Ultrasound: 'US',
  'Ultrasound Bone Densitometry': 'BDUS',
  'Visual Acuity': 'VA',
  'X-Ray': 'XA',
  Other: 'other',
};

export const IMAGING_TEST_TYPE_OPTIONS = Object.keys(
  IMAGING_TEST_DIAGNOSTIC_REPORT_TYPE_MAP
).map((entry) => ({ k: entry, v: entry }));
